import React, { useEffect } from 'react'

import Grid from '@mui/material/Grid'

import Login from './Login'
import Dashboard from './Dashboard'

import { useAuth } from '../../contexts/AuthContext'
import { useSideNav } from '../../contexts/SideNavOpenContext.js'

const Home = () => {
  const { user, setUser, accounts, isAuth } = useAuth()
  const { sideNavOpen } = useSideNav(true)

  useEffect(() => {
    if (!user && isAuth) {
      setUser({
        name: accounts[0].name,
        email: accounts[0].username.toLowerCase(),
      })
    }
  }, [user, accounts, setUser, isAuth])

  return (
    <>
      <Grid
        container
        direction={isAuth ? 'row' : 'column'}
        justifyContent='center'
        alignItems='center'
        sx={{
          pl: sideNavOpen ? '260px' : '60px',
          pt: '70px',
          pr: '10px',
          pb: '100px',
        }}
      >
        {isAuth ? <Dashboard /> : <Login />}
      </Grid>
    </>
  )
}

export default Home
